module.exports = __webpack_public_path__ + "img/gabi.f10f13b.png";